import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { TextField } from 'material-ui';
import { updateVesselSale } from 'actions/vessels/sales';


class SaleInputs extends React.Component {

    onChangePrice = (type, value) => {
        this.props.updateVesselSale(this.props.numberSaleTable, { ...Object.assign({}, this.props.vesselSale), [type]: value });
    }

    render() {
        let { ideaPrice, salePrice } = this.props.vesselSale;
        return (
            <div className="row">
                <div>
                    <TextField 
                        style={{ fontSize: '13px', marginLeft: "10px" }}
                        value={ ideaPrice || ''}
                        hintText='Price Idea'
                        onChange={e => this.onChangePrice("ideaPrice", e.target.value)}
                        floatingLabelText='Price Idea'
                    />  
                </div>
                <div>
                    <TextField 
                        style={{ fontSize: '13px', marginLeft: "10px" }}
                        value={ salePrice || ''}
                        hintText='Sale Price'
                        onChange={e => this.onChangePrice("salePrice", e.target.value)}
                        floatingLabelText='Sale Price'
                    />  
                </div>
            </div>
        );
    }
}

export default connect(
    (state, ownProps) => {
        
        const errorVesselName = state.vesselSales.items[ownProps.numberSaleTable].validateErrors.find((validateError) => {
            return validateError.field === 'vessel';
        });

        return {
            numberSaleTable: ownProps.numberSaleTable,
            errorVesselName,
            vesselSale: state.vesselSales.items[ownProps.numberSaleTable],
        };
    },
    dispatch => bindActionCreators({
        updateVesselSale,
    }, dispatch),
)(SaleInputs);



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Sales/Order/Sale.jsx